"use strict";
/// <reference path="irep.js"/>

IREP.forum = (function () {
    var options;
    var wysiwygEditor = null;
    var wysiwygEditorLoading = false; //Singleton value, controls if the wysiwyg editor is currently in the loading process.
    var wysiwygCurrentMode = null;

    var init = function (forumOptions) {
        options = forumOptions;

        // terms
        $("#acceptTerms").click(acceptTerms);
        $("#denyTerms").click(denyTerms);

        $("#addReply").click(addReply);
        $("#addReply2").click(addReply);

        $("#forumPage").on("click", ".replyWithQuote", function () {
            addReply(this);
            return false;
        });

        $("#forumPage").on("click", ".editCurrentPost", function () {
            editMessage(this);
            return false;
        });

        $("#forumPage").on("click", ".delete", function () {
            if (confirm('Are you sure you want to delete this post? This action cannot be undone.')) {
                deleteMessage(this);
            }
            return false;
        });

        $("#forumPage").on("click", ".toggleSticky", function () {
            stickyTopic(this);
            return false;
        });
        $("#forumPage").on("click", ".toggleLock", function () {
            lockTopic(this);
            return false;
        });
        $("#forumPage").on("click", ".merge", function () {
            mergeTopic(this);
            return false;
        });
        var sTopicMerge = sessionStorage.getItem("mergeTopic");
        if (sTopicMerge != null) {
            $(".merge").each(function (i, element) {
                var item = $(element).parents(".topic").prop("id");
                if (item === sTopicMerge) {
                    $(element).text("");
                } else {
                    $(element).text("Merge Destination");
                    $(element).after("<span class='divider'>|</span><a href='#' class='mergeCancel'>Cancel Merge</a>");
                    $("#forumPage").on("click", ".mergeCancel", function () {
                        mergeTopicCancel();
                        return false;
                    });
                };
            });
        };

        $("#createTopic").click(createTopic);
        $("#createTopic2").click(createTopic);

        var defaultSearchValue = $("#searchForm").find("input[id$=query]")
            .focus(function () {
                if ($(this).val() === defaultSearchValue) {
                    $(this).val("");
                }
            })
            .blur(function () {
                if ($(this).val() === "") {
                    $(this).val(defaultSearchValue);
                }
            })
            .val();


        $("#search").click(search);
        $("#legend").find("#toggle").on("click", function () {
            $("#statuses").toggle();
            $("#legend").toggleClass("opened");

        });

        $(document).click(function (e) {
            if ($("#legend").hasClass("opened") && !$.contains($("#legend")[0], e.target)) {
                $("#statuses").toggle();
                $("#legend").toggleClass("opened");
            }
        });

        $(document).on("keypress", "#searchForm", function () {
            if (event.which === 13) {
                search();
            }
        });

        setTimeout(function () {
            if (window.location.hash) {
                scrollToMessage(window.location.hash);
                highlightMessage(window.location.hash);
            }
        }, 1);

        $("#forumPage").on("click", ".gotoBeginning", function () {
            IREP.redirect($(this).find("a:first").prop("href"));
            return false;
        });
        $("#forumPage").on("click", ".gotoEnd", function () {
            IREP.redirect($(this).find("a:first").prop("href"));
            return false;
        });

        // example
        $("#newTopic").submit(function () {
            var fakeForm = $(this);
            var data = fakeForm.serializeForm();
            return false;
        });

        $("#forumPage").on("click", ".upVote", { rating: true }, vote);
        $("#forumPage").on("click", ".downVote", { rating: false }, vote);

        $("#forumPage").show();
    };

    var highlightMessage = function (messageId) {
        if (window.location.hash) {
            var message = $(messageId);
            var oldColor = message.css("background-color");
            message.css({ backgroundColor: "#FFF8DC" }).animate({ backgroundColor: oldColor }, { duration: 2500 });
        }
    };

    var vote = function (event) {
        var message = $(this).parents(".message");
        var messageParent = message.parent();
        var messageId = message.prop("id");
        var pageId = messageParent.data("pageId");
        var isUpVote = event.data.rating;
        var data = { messageId: messageId, isUpVote: isUpVote };
        IREP.callApi("forum/message/vote", "POST", data)
            .done(function () {
                gotoPage(messageParent, pageId, messageId);
            });

    };

    var acceptTerms = function () {
        IREP.callApi("forum/user/accept-terms", "POST", null)
            .done(function () {
                IREP.refresh();
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                IREP.displayError("Error accepting terms, please try again later.");
            });

    };

    var denyTerms = function () {
        IREP.redirect(IREP.options.appUrl + IREP.options.user.geoCode.toLowerCase() + '/home');
    };

    var scrollToMessage = function (message) {
        message = typeof (message) === "string" && message.substring(0, 1) === '#' ? message : "#" + message;
        var scrollPosition = $(message).position().top - parseInt($("body").css("padding-top"), 10);
        highlightMessage(message);
        $(window).scrollTop(scrollPosition);
    };

    var gotoPage = function (container, page, message) {
        var url = "";
        var pager = $(".pager");
        if (pager.length > 0) {
            url = pager.find("a:first").prop("href");
        } else {
            url = window.location.href;
        }
        url = url.replace(/page=[^&]+&?/, "page=" + page);
        if (url.indexOf("page=") < 0) {
            url += "&page=" + page;
        }
        url += "#" + message;
        var containerId = "#" + container.prop("id");
        container.one("pjax:success", function () {
            scrollToMessage(message);
        });

        // don't use this pjax behavior in IE8
        if ($.support.pjax) {
            $.pjax({ url: url, container: containerId, timeout: IREP.options.pJaxTimeout });
        } else {
            IREP.redirect(url); // IE8 sees the redirect is on the same page and just sets the hash and scrolls
            IREP.refresh(); // so then we need to actually refresh the contents to get the updated view after the vote
        }
    };

    /*
     * Checks if the content has actual text. 
     */
    var isNotEmpty = function (value) {
        return $.trim($('<div>').html(value).text()) != "";
    }


    var saveReply = function (successFunction, failFunction) {
        var content = $("#messageContent").val();
        if (isNotEmpty(content)) {
            var postData = {
                categoryId: options.categoryId,
                forumId: options.forumId,
                topicId: options.topicId,
                text: content
            };
            IREP.callApi("forum/addReply", "POST", postData)
                .done(function (data) {
                    successFunction();
                    gotoPage($("#messages"), data.lastPage, data.messageId);

                }).fail(function (jqXHR, textStatus, errorThrown) {
                    failFunction();
                });
        }
        else {
            failFunction();
        }
        return false;
    };

    var saveTopic = function (successFunction, failFunction) {
        var content = $("#messageContent").val();
        var title = $("#title").val()
        if (isNotEmpty(content) && $.trim(title) != "") {
            var postData = {
                categoryId: options.categoryId,
                forumId: options.forumId,
                title: title,
                text: content
            };
            IREP.callApi("forum/addTopic", "POST", postData)
                .done(function (data) {
                    successFunction();
                    gotoPage($("#topics"), 1, data.topicId);
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    failFunction();
                });
        }
        else {
            failFunction();
        }

        return false;
    };

    var saveEdit = function (successFunction, failFunction) {
        var content = $("#messageContent").val();
        var title = $("#title").val()
        if (isNotEmpty(content) && ($("#title").length == 0 || $.trim(title) != "")) {
            var messageId = $(".replyContainer").data("messageId");
            var isTopicEdit = $("#title").length > 0;
            var postData = {
                categoryId: options.categoryId,
                messageId: messageId,
                text: content,
                title: title
            };
            IREP.callApi("forum/update-post", "POST", postData)
                .done(function (data) {
                    successFunction();
                    if (isTopicEdit) {
                        IREP.refresh();
                    } else {

                        gotoPage($("#messages"), $("#messages").data("pageId"), messageId);
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    failFunction();
                });
        }
        else {
            failFunction();
        }
    };

    var addReply = function (sender) {
        var textVal = "<p>&nbsp;</p>";

        if (sender !== null && sender !== undefined) {
            var originName = $.trim($(sender).parent().parent(".content").children(".meta").children(".authorInfo").children(".name").text());
            if (originName != undefined && originName != null && originName != "") {
                textVal = "<blockquote><p><b>" + originName + "</b>:</p><p>" + $(sender).parent().parent(".content").children(".text").html() + "</p></blockquote><p>&nbsp;</p>";
            }
        }
        if (wysiwygCurrentMode !== "replyeditor") {
            wysiwygEditor = null; //Need to re-load wysiEditor. 
            $(".createTopic.container").remove(); //Remove any existing container from the DOM so the new container will render properly. 
        }

        if (wysiwygEditor == null && wysiwygEditorLoading === false) {
            wysiwygEditorLoading = true;
            wysiwygCurrentMode = "replyeditor";
            $.get(IREP.options.appUrl + IREP.options.user.site.toLowerCase() + "/replyeditor.ajax", {}, function (html) {
                wysiwygEditor = IREP.wysiwyg.init({
                    container: $("<div>").addClass("replyContainer").append(html).appendTo("body"),
                    wysiwygId: "messageContent",
                    saveFunction: saveReply,
                    additionalPadding: 150,
                    failureText: options.failureText,
                    successText: options.successText
                });
            }).done(function () {
                textVal = textVal.replace(/\u00a0/g, ' ');
                var oldStyleReplyRegex = new RegExp(/<table(\s*(cellspacing="0"|cellpadding="0"|class="forum")\s*)*>\s*<tbody>\s*<tr>\s*<td>/g);
                if (oldStyleReplyRegex.test(textVal)) {
                    textVal = textVal.replace(oldStyleReplyRegex, "").replace(/<\/td>\s*<\/tr>\s*<\/tbody>\s*<\/table>/, "");
                }
                $("#messageContent").html(textVal);
                wysiwygEditorLoading = false;
                $("#WysiwygListEffects").hide();
            });
        } else if (wysiwygEditor !== null) {
            wysiwygEditor.show();
            $(".wysihtml5-sandbox").contents().find(".wysihtml5-editor").html(textVal);
            wysiwygEditor.updateSaveFunction(saveReply);
        }
        return false;
    };

    var createTopic = function () {
        //Create Topic is always done on a different page. Therefore, no need to set the wysiwyg mode. 
        var textVal = "<p>&nbsp;</p>";
        if (wysiwygEditor == null && wysiwygEditorLoading === false) {
            wysiwygEditorLoading = true;
            $.get(IREP.options.appUrl + IREP.options.user.site.toLowerCase() + "/topiceditor.ajax", {}, function (html) {
                wysiwygEditor = IREP.wysiwyg.init({
                    container: $("<div>").addClass("createTopicContainer").append(html).appendTo("body"),
                    wysiwygId: "messageContent",
                    saveFunction: saveTopic,
                    additionalPadding: 230,
                    failureText: options.failureText,
                    successText: options.successText
                });
            }).done(function () {
                $("#messageContent").html(textVal);
                wysiwygEditorLoading = false;
                $("#WysiwygListEffects").hide();
            });
        } else if (wysiwygEditor !== null) {
            wysiwygEditor.show();
            $(".wysihtml5-sandbox").contents().find(".wysihtml5-editor").html(textVal);
            wysiwygEditor.updateSaveFunction(saveTopic);
        }

        return false;
    };

    var editMessage = function (element) {
        var message = $(element).parents(".message");
        var textVal = message.find(".text").html();
        var mode = (message.data("isTopicStart") ? "topiceditor" : "replyeditor");
        if (mode !== wysiwygCurrentMode) {
            wysiwygEditor = null; //Need to re-load wysiEditor. 
            //Remove any existing container from the DOM so the new container will render properly. 
            if (mode === "replyeditor") {
                $(".createTopic.container").remove(); 
            }
            else {
                $(".reply.container").remove();
            }
        }
        if (wysiwygEditor == null && wysiwygEditorLoading === false) {
            wysiwygEditorLoading = true;
            wysiwygCurrentMode = mode; 
            var editor = "/" + mode + ".ajax";
            $.get(IREP.options.appUrl + IREP.options.user.site.toLowerCase() + editor, {}, function (html) {
                wysiwygEditor = IREP.wysiwyg.init({
                    container: $("<div>").addClass("replyContainer").append(html).appendTo("body"),
                    wysiwygId: "messageContent",
                    saveFunction: saveEdit,
                    additionalPadding: 150,
                    failureText: options.failureText,
                    successText: options.successText
                });
            }).done(function () {
                $(".replyContainer").data("messageId", message.prop("id"));
                $("#title").val($("#pageName").text());
                $("#messageContent").html(textVal);
                wysiwygEditorLoading = false;
                $("#WysiwygListEffects").hide();
            });
        } else if (wysiwygEditor !== null) {
            wysiwygEditor.show();
            $(".wysihtml5-sandbox").contents().find(".wysihtml5-editor").html(textVal);
            $(".replyContainer").data("messageId", message.prop("id"));
            wysiwygEditor.updateSaveFunction(saveEdit);
        }

    };

    var deleteMessage = function (element) {
        var item = $(element).parents(".message, .topic");
        IREP.callApi("/forum/delete-post", "POST", { messageId: item.prop("id") })
            .done(function () {
                IREP.refresh();
                return false;
            });
    };
    var stickyTopic = function (element) {
        var item = $(element).parents(".topic");
        IREP.callApi("/forum/sticky-topic", "POST", { topicId: item.prop("id"), stuck: !item.find(".toggleSticky").data("isSticky") })
            .done(function () {
                IREP.refresh();
                return false;
            });
    };
    var lockTopic = function (element) {
        var item = $(element).parents(".topic");
        var params = { topicId: item.prop("id"), locked: !item.find(".toggleLock").data("isLocked") };
        IREP.callApi("/forum/lock-topic", "POST", params)
            .done(function () {
                IREP.refresh();
                return false;
            });
    };
    var mergeTopic = function (element) {
        var item = $(element).parents(".topic");
        var params;
        if (sessionStorage.getItem("mergeTopic") === null) {
            sessionStorage.setItem("mergeTopic", item.prop("id"));
            IREP.refresh();
        } else {
            params = {
                sTopicId: sessionStorage.getItem("mergeTopic"),
                tTopicId: item.prop("id"),
                targetForumId: options.forumId
            };
            IREP.callApi("forum/merge-topic", "POST", params).done(
                function () {
                    sessionStorage.removeItem("mergeTopic");
                    IREP.refresh();
                    return false;
                }
            );
        }
    };
    var mergeTopicCancel = function () {
        sessionStorage.removeItem("mergeTopic");
        IREP.refresh();
        return false;
    };

    var search = function () {
        var searchForm = $("#searchForm");
        var searchOptions = searchForm.serializeForm();
        if (options.categoryId) {
            searchOptions.push({ name: "categoryId", value: options.categoryId });
            if (options.forumId) {
                searchOptions.push({ name: "forumId", value: options.forumId });
                if (options.topicId) {
                    searchOptions.push({ name: "topicId", value: options.topicId });
                }
            }
        }
        var searchUrl = searchForm.find("#search").prop("href") + "?" + $.param(searchOptions);
        IREP.redirect(searchUrl);
        return false;
    };

    return {
        init: init
    };
})();